// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-display-platform-Document-InvoiceDetail-footer__footer--2kde7"};


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/Document/InvoiceDetail/footer.scss
// module id = 6554
// module chunks = 0